import script from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleManagement.vue?vue&type=script&setup=true&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=645310df&lang=scss"

const __exports__ = script;

export default __exports__